import { useEffect } from "react";
import { useAnalyticsStore } from "../store";

/**
 * Applies the deep link's `?story=`/`?version=` to the filters on mount.
 *
 * The store derives its initial selection from the URL, which is right on a full
 * load of the analytics page and useless on a click through from the Stories
 * list: the module was evaluated on whatever page the app started on, long
 * before those params existed. So the link navigated, the query string was
 * there, and the dashboard came up unfiltered — while a refresh looked like it
 * fixed the feature.
 *
 * In an effect, not during render: the previous attempt at reading the URL here
 * did it inside a `useState` initializer, and a store write during render is
 * something React 18 is free to discard and replay.
 */
export const useAdoptUrlSelection = () => {
  const adoptUrlSelection = useAnalyticsStore((s) => s.adoptUrlSelection);

  useEffect(() => {
    adoptUrlSelection();
  }, [adoptUrlSelection]);
};
